import { FC, memo } from 'react'

import NavbarListItems from './navbar-list-items'

import { navBarItemsAll, navBarItemsRestricted } from '../data'

interface INavbarList {
  isHamburgerOpen: boolean
  pathname: string
  closeMenu: () => void
  isRestricted?: boolean
}

const NavbarList: FC<INavbarList> = ({
  isHamburgerOpen,
  closeMenu,
  pathname,
  isRestricted = false,
}: INavbarList) => {
  return (
    <NavbarListItems
      closeMenu={closeMenu}
      pathname={pathname}
      isHamburgerOpen={isHamburgerOpen}
      navBarItems={isRestricted ? navBarItemsRestricted : navBarItemsAll}
    />
  )
}
export default memo(NavbarList)
